import React, { Component } from 'react';
import PropTypes from 'prop-types';
import text from '../assets/texts.json';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {
    return (
      <React.Fragment>
        <span>
          <a href={text.copyrights_link}>{text.copyrights_text}</a> &copy;
          {new Date().getFullYear()}
        </span>
        <span className="ml-auto text-info">{text.version}</span>
        <span className="ml-auto">{text.footer_text}</span>
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
